import { render, staticRenderFns } from "./DirectiveHelp.vue?vue&type=template&id=2b7c79b2"
import script from "./DirectiveHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectiveHelp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports